import { authRequest } from './index.js'

export async function get_report(report_id){
  let data
  // console.log("🚀 ~ file: child.js:39 ~ retrieve_children ~ authRequest:", authRequest)
  await authRequest.get(
    '/report/' + report_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    // console.log("🚀 ~ file: child.js:32 ~ retrieve_children ~ error:", error)
    data = {error: true, result: error.response?.data || error.message || 'Unknown error'}
  })
  return data
}